import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { gql } from "@apollo/client";
import { taxCalculation, isDateRangeIn, values } from "./helper";
import { COURSE_TRIAL_DURATION_UNIT, CONTRACTABLE_BUFFER } from "@/lib/constants";
import dayjs from "@/lib/day";
import config from "@/lib/config";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type CoursePrice {\n    id: ID\n    price: Int\n    payment_amount: Int\n    validity_start_at: String\n    validity_end_at: String\n    validityEndAt: String\n    campaignId: Int\n    campaign: Campaign\n  }\n\n  type Course {\n    id: ID!\n    name: String!\n    thumbnailUrl: String\n    description: String\n    validity_start_at: String\n    validity_end_at: String\n    price: Int\n    priceWithoutTax: Int\n    defaultPrice: Int\n    defaultPriceWithoutTax: Int\n    discount_price: Int\n    active_pricing: CoursePrice\n    rightIds: [Int]\n    trial_flag: Boolean\n    trial_date: String\n    trialTerm: String\n    trial_term_unit: String\n    trialTermText: String\n    trialText: String\n    trialDate: String\n    ref_id: String\n    valuePlan: Boolean\n    questionId: Int\n    channel: ChannelMeta\n    trialCampaignFlag: Boolean\n    contractAllowed: Boolean\n  }\n\n  type Query {\n    courseById(courseId: Int): Course\n    courseByRightId(rightId: Int): Course\n    courseByMetaId(metaId: Int): Course\n  }\n"])));
export var resolvers = {
  Query: {
    courseById: function () {
      var _courseById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, _ref, _ref2) {
        var courseId, dataSources, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                courseId = _ref.courseId;
                dataSources = _ref2.dataSources;
                _context.next = 4;
                return dataSources.courses.courseById(courseId);

              case 4:
                res = _context.sent;

                if (!res) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", _objectSpread({}, res));

              case 9:
                return _context.abrupt("return", null);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function courseById(_x, _x2, _x3) {
        return _courseById.apply(this, arguments);
      }

      return courseById;
    }(),
    courseByRightId: function () {
      var _courseByRightId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_parent, _ref3, _ref4) {
        var rightId, dataSources, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                rightId = _ref3.rightId;
                dataSources = _ref4.dataSources;
                _context2.next = 4;
                return dataSources.right.courses(rightId);

              case 4:
                res = _context2.sent;

                if (!res) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", res.courses[0]);

              case 9:
                return _context2.abrupt("return", null);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function courseByRightId(_x4, _x5, _x6) {
        return _courseByRightId.apply(this, arguments);
      }

      return courseByRightId;
    }(),
    courseByMetaId: function () {
      var _courseByMetaId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_parent, _ref5, _ref6) {
        var _channel$values, _channel$values$right;

        var metaId, dataSources, channel, right, res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                metaId = _ref5.metaId;
                dataSources = _ref6.dataSources;
                _context3.next = 4;
                return dataSources.meta.channelDetail(metaId);

              case 4:
                channel = _context3.sent;
                right = channel === null || channel === void 0 ? void 0 : (_channel$values = channel.values) === null || _channel$values === void 0 ? void 0 : (_channel$values$right = _channel$values.rights) === null || _channel$values$right === void 0 ? void 0 : _channel$values$right[0];

                if (!right) {
                  _context3.next = 13;
                  break;
                }

                _context3.next = 9;
                return dataSources.right.courses(right.id);

              case 9:
                res = _context3.sent;
                return _context3.abrupt("return", res.courses[0]);

              case 13:
                return _context3.abrupt("return", null);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function courseByMetaId(_x7, _x8, _x9) {
        return _courseByMetaId.apply(this, arguments);
      }

      return courseByMetaId;
    }()
  },
  Course: {
    id: function id(course) {
      return course.id || course.course_id;
    },
    thumbnailUrl: function thumbnailUrl(course, _args, _ref7) {
      var req = _ref7.req;
      var noimage = req.adultMode ? "/images/noimage_ex.png" : "/images/noimage.png";
      return (course === null || course === void 0 ? void 0 : course.thumbnail_url) || noimage;
    },
    // キャンペーンが適用されていたらキャンペーンの価格になる
    price: function price(course) {
      var _course$active_pricin;

      return course === null || course === void 0 ? void 0 : (_course$active_pricin = course.active_pricing) === null || _course$active_pricin === void 0 ? void 0 : _course$active_pricin.payment_amount;
    },
    priceWithoutTax: function priceWithoutTax(course) {
      var _course$active_pricin2;

      return course === null || course === void 0 ? void 0 : (_course$active_pricin2 = course.active_pricing) === null || _course$active_pricin2 === void 0 ? void 0 : _course$active_pricin2.price;
    },
    // course_pricingsの中からキャンペーンが設定されていない価格を取得する
    defaultPrice: function defaultPrice(course) {
      var price = course === null || course === void 0 ? void 0 : course.course_pricings.filter(function (cp) {
        return !(cp !== null && cp !== void 0 && cp.campaign) && !(cp !== null && cp !== void 0 && cp.campaign_id);
      }).map(function (cp) {
        return cp.payment_amount;
      }).reduce(function (acc, current) {
        return acc > current ? current : acc;
      });
      return price;
    },
    defaultPriceWithoutTax: function defaultPriceWithoutTax(course) {
      var price = course === null || course === void 0 ? void 0 : course.course_pricings.filter(function (cp) {
        return !(cp !== null && cp !== void 0 && cp.campaign) && !(cp !== null && cp !== void 0 && cp.campaign_id);
      }).map(function (cp) {
        return cp.price;
      }).reduce(function (acc, current) {
        return acc > current ? current : acc;
      });
      return price;
    },
    discount_price: function () {
      var _discount_price = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(course, _args, _ref8) {
        var _right$values;

        var dataSources, refId, right, discount_price;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dataSources = _ref8.dataSources;
                refId = course === null || course === void 0 ? void 0 : course.ref_id;
                _context4.next = 4;
                return dataSources.right.rightsByRefId(refId);

              case 4:
                right = _context4.sent;
                discount_price = taxCalculation(right === null || right === void 0 ? void 0 : (_right$values = right.values) === null || _right$values === void 0 ? void 0 : _right$values.discount_price);
                return _context4.abrupt("return", discount_price);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function discount_price(_x10, _x11, _x12) {
        return _discount_price.apply(this, arguments);
      }

      return discount_price;
    }(),
    rightIds: function rightIds(course) {
      return course === null || course === void 0 ? void 0 : course.right_ids;
    },
    valuePlan: function valuePlan(course) {
      var id = course.id || course.course_id;
      return Number(id) === config.valuePlan.courseId;
    },
    trialCampaignFlag: function () {
      var _trialCampaignFlag = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(course, _args, context) {
        var _yield$fakeTrialCampa, _yield$fakeTrialCampa2, trialCampaignFlag;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return fakeTrialCampaignFlag(course, context);

              case 2:
                _yield$fakeTrialCampa = _context5.sent;
                _yield$fakeTrialCampa2 = _slicedToArray(_yield$fakeTrialCampa, 1);
                trialCampaignFlag = _yield$fakeTrialCampa2[0];
                return _context5.abrupt("return", trialCampaignFlag);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function trialCampaignFlag(_x13, _x14, _x15) {
        return _trialCampaignFlag.apply(this, arguments);
      }

      return trialCampaignFlag;
    }(),
    trialTerm: function trialTerm(course) {
      if (course !== null && course !== void 0 && course.trial_term && course !== null && course !== void 0 && course.trial_term_unit) {
        var unit = COURSE_TRIAL_DURATION_UNIT[course.trial_term_unit].label;
        return "".concat(course.trial_term).concat(unit);
      }
    },
    trialTermText: function () {
      var _trialTermText = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(course, _args, context) {
        var unit, _yield$fakeTrialCampa3, _yield$fakeTrialCampa4, trialCampaignFlag, actual, fakeTrial;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(course !== null && course !== void 0 && course.trial_term && course !== null && course !== void 0 && course.trial_term_unit)) {
                  _context6.next = 12;
                  break;
                }

                unit = COURSE_TRIAL_DURATION_UNIT[course.trial_term_unit].label;
                _context6.next = 4;
                return fakeTrialCampaignFlag(course, context);

              case 4:
                _yield$fakeTrialCampa3 = _context6.sent;
                _yield$fakeTrialCampa4 = _slicedToArray(_yield$fakeTrialCampa3, 3);
                trialCampaignFlag = _yield$fakeTrialCampa4[0];
                actual = _yield$fakeTrialCampa4[1];
                fakeTrial = _yield$fakeTrialCampa4[2];

                if (!(trialCampaignFlag && !actual)) {
                  _context6.next = 11;
                  break;
                }

                return _context6.abrupt("return", "".concat(fakeTrial.term).concat(fakeTrial.unit, "\u7121\u6599\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3"));

              case 11:
                return _context6.abrupt("return", trialCampaignFlag ? "".concat(course.trial_term).concat(unit, "\u7121\u6599\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3") : "".concat(course.trial_term).concat(unit, "\u7121\u6599\u30C8\u30E9\u30A4\u30A2\u30EB"));

              case 12:
                return _context6.abrupt("return", null);

              case 13:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function trialTermText(_x16, _x17, _x18) {
        return _trialTermText.apply(this, arguments);
      }

      return trialTermText;
    }(),
    trialText: function () {
      var _trialText = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(course, _args, _ref9) {
        var req, dataSources, unit, _yield$fakeTrialCampa5, _yield$fakeTrialCampa6, trialCampaignFlag, actual, fakeTrial;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                req = _ref9.req, dataSources = _ref9.dataSources;

                if (!(course !== null && course !== void 0 && course.trial_term && course !== null && course !== void 0 && course.trial_term_unit)) {
                  _context7.next = 13;
                  break;
                }

                unit = COURSE_TRIAL_DURATION_UNIT[course.trial_term_unit].label;
                _context7.next = 5;
                return fakeTrialCampaignFlag(course, {
                  req: req,
                  dataSources: dataSources
                });

              case 5:
                _yield$fakeTrialCampa5 = _context7.sent;
                _yield$fakeTrialCampa6 = _slicedToArray(_yield$fakeTrialCampa5, 3);
                trialCampaignFlag = _yield$fakeTrialCampa6[0];
                actual = _yield$fakeTrialCampa6[1];
                fakeTrial = _yield$fakeTrialCampa6[2];

                if (!(trialCampaignFlag && !actual)) {
                  _context7.next = 12;
                  break;
                }

                return _context7.abrupt("return", "".concat(fakeTrial.term).concat(fakeTrial.unit, "\u7121\u6599\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3"));

              case 12:
                return _context7.abrupt("return", trialCampaignFlag ? "".concat(course.trial_term).concat(unit, "\u7121\u6599\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3") : "無料トライアル");

              case 13:
                return _context7.abrupt("return", null);

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function trialText(_x19, _x20, _x21) {
        return _trialText.apply(this, arguments);
      }

      return trialText;
    }(),
    trialDate: function trialDate(course) {
      if (course.trial_date) {
        return dayjs(course.trial_date).format("YYYY/MM/DD");
      } else {
        return "";
      }
    },
    questionId: function questionId(course) {
      var _course$values;

      var questionId = course === null || course === void 0 ? void 0 : (_course$values = course.values) === null || _course$values === void 0 ? void 0 : _course$values.question_id;

      if (typeof questionId === "object") {
        return questionId === null || questionId === void 0 ? void 0 : questionId.question_id;
      } else if (typeof questionId === "number") {
        return questionId;
      }
    },
    channel: function () {
      var _channel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(parent, _args, _ref10) {
        var dataSources, _res$values, res, _channel2;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                dataSources = _ref10.dataSources;

                if (!(parent !== null && parent !== void 0 && parent.ref_id)) {
                  _context8.next = 9;
                  break;
                }

                _context8.next = 4;
                return dataSources.right.rightsByRefId(parent.ref_id);

              case 4:
                res = _context8.sent;
                _context8.next = 7;
                return dataSources.meta.channelDetail(res === null || res === void 0 ? void 0 : (_res$values = res.values) === null || _res$values === void 0 ? void 0 : _res$values.channel);

              case 7:
                _channel2 = _context8.sent;
                return _context8.abrupt("return", _channel2);

              case 9:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function channel(_x22, _x23, _x24) {
        return _channel.apply(this, arguments);
      }

      return channel;
    }(),
    contractAllowed: function contractAllowed(course) {
      return isDateRangeIn(course === null || course === void 0 ? void 0 : course.contractable_start_at, course === null || course === void 0 ? void 0 : course.contractable_end_at, {
        buffer: CONTRACTABLE_BUFFER,
        default: true
      });
    }
  },
  CoursePrice: {
    id: function id(cp) {
      return cp.course_pricing_id;
    },
    campaignId: function campaignId(cp) {
      var _cp$campaign;

      if (cp !== null && cp !== void 0 && cp.campaign_id) return Number(cp.campaign_id);
      if (cp !== null && cp !== void 0 && cp.campaign) return Number(cp === null || cp === void 0 ? void 0 : (_cp$campaign = cp.campaign) === null || _cp$campaign === void 0 ? void 0 : _cp$campaign.campaign_id);
      return null;
    }
  }
};
/**
  * @typedef FakeTrial
  * @property {number} term
  * @property {string} unit

/**
 * fakeTrialCampaignFlag.
 *
 * xx日間無料キャンペーン終了対応
 * 文言の出しわけにCourseのtrial_campaign_flagを使っているが、キャンペーン終了に伴いフラグがオフになる
 * フラグがオンのときにトライアルになったユーザーにはご利用状況ページでキャンペーン文言を出す必要がある
 * 特定のコースの場合にユーザーのsubscriptionの状態をみてフラグを偽装するようにする
 *
 * @param {Course} course
 * @param {Object} context
 * @param {Object} context.req
 * @param {Object} context.dataSources
 * @returns {Promise<(boolean|FakeTrial)[]>}
 */

function fakeTrialCampaignFlag(_x25, _x26) {
  return _fakeTrialCampaignFlag.apply(this, arguments);
}

function _fakeTrialCampaignFlag() {
  _fakeTrialCampaignFlag = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(course, _ref11) {
    var req, dataSources, courseId, target, subscription, trialStartAt;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            req = _ref11.req, dataSources = _ref11.dataSources;
            courseId = course.id || course.course_id;
            target = config.trialCamapignTextDisplay.find(function (v) {
              return v.courseId === courseId;
            });

            if (!(target && req.userToken)) {
              _context9.next = 10;
              break;
            }

            _context9.next = 6;
            return dataSources.subscribe.subscriptionFromCourseId(courseId);

          case 6:
            subscription = _context9.sent;

            if (!(subscription && (subscription === null || subscription === void 0 ? void 0 : subscription.status) === "trial")) {
              _context9.next = 10;
              break;
            }

            // if (subscription && subscription?.status === "trial") {
            // トライアル開始日時がendAt以前であればキャンペーンとみなす
            trialStartAt = dayjs(new Date(subscription.trial_start_at));
            return _context9.abrupt("return", [trialStartAt.isSameOrBefore(target.endAt, "secound"), false, {
              term: target.term,
              unit: target.unit
            }]);

          case 10:
            return _context9.abrupt("return", [!!values(course, "trial_campaign_flag"), true]);

          case 11:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _fakeTrialCampaignFlag.apply(this, arguments);
}